(function () {
    'use strict';

    angular.module('l4b')
        .component('requiredDocumentationAdditional', {
            templateUrl: 'html/shared/requiredDocumentationAdditional/requiredDocumentationAdditional.html',
 			bindings: {
				nextStep: '&'
			},			
			controller: RequiredDocumentationAdditionalController,

			controllerAs: 'vm'
        });

    RequiredDocumentationAdditionalController.$inject = ['$scope', 'Constants', 'GuidedProofService', 'StorageService', 'RestService'];

    function RequiredDocumentationAdditionalController($scope, Constants, GuidedProofService, StorageService, RestService) {
        var vm = this;

        angular.extend(vm, {
			$onInit: init,
            onChange: onChange,
            onError: onError,
            showChooseFiles: true,
            allowedFileFormats: ".png, .jpeg, .jpg, .pdf",
            allowedFileMimeType: "image/png,image/jpeg,image/jpg,application/pdf",
            proof: null,
            anotherFile: anotherFile
        });
		
		function init() {
			vm.proofData = GuidedProofService.GetCurrentProofData();
            loadAllowedFormatsConfig();
		}			
		
        function loadAllowedFormatsConfig(){
            var config = StorageService.get(Constants.SK.Configuration);
            if(config){
                vm.allowedFileFormats = config.allowedFileFormats || vm.allowedFileFormats;
                vm.allowedFileMimeType = config.allowedFileMimeType || vm.allowedFileMimeType;
            }
        }
		function anotherFile() {
			
			GuidedProofService.RequestAnotherFile();
			
			vm.nextStep({ options: { askAdditionalFile: true }});
		}

        function onChange() {
            
            GuidedProofService.RequestAnotherFile();

            RestService.trackApplicationEvent(Constants.Event.Telesales.SYSTEM_IDENTITY_PROOF_PROVIDED);

            StorageService.set(Constants.SK.FileData, vm.fileToUpload);

            GuidedProofService.ShowImageReviewPage(true);

            vm.nextStep({ options: { review: true } });
        }

        function onError(errorText) {

            StorageService.set(Constants.SK.FileData, { error: errorText });

            GuidedProofService.ShowImageReviewPage(true);

            vm.nextStep({ options: { review: true } });
        }
    }

})();